/* eslint-disable guard-for-in */
import http from './request';

// const getPrescriptionList = (params) => http.get('/prscircle/prescription/prescriptionByUserId', { params });
const getPrescriptionList = (params, config) => http.get('/cloud-pharmacy/prescription/page', { app: 'banyanSi', params, ...config, });
const getPrescriptionDetail = (params, config) => http.get('/cloud-pharmacy/prescription/detail', { app: 'banyanSi', params, ...config, });
// const getPrescriptionDetail = (params) => http.post('/prscircle/prescription/prescriptionDetailByPrsId', params, {
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded',
//   },
//   transformRequest: [
//     (data) => {
//       let ret = '';
//       Object.keys(data).forEach((it) => {
//         ret += `${encodeURIComponent(it)}=${encodeURIComponent(data[it])}&`;
//       });
//
//       return ret;
//     },
//   ],
// });

// 店员端
const getPrescriptionDetailNew = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/mall-assistant/prescription/compatible/detail',
  data: params,
});

// 获取专家问诊处方预约买药的下单页 prescriptionId
const getOrderJumpUrl = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/cloud-pharmacy/prescription/getOrderUrl',
  data: params,
});
// const getOrderJumpUrl = (params) => http.get('/prscircle/prescription/getOrderUrl', { params });
const createByPres = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/cloud-pharmacy/order/createByPres',
  data: params,
});

// 查询处方流转信息
const getTransferInfo = (params) =>
  http({
    app: 'banyanSi',
    method: 'post',
    url: '/cloud-pharmacy/medins/transferInfo',
    data: params,
  });

// 处方流转授权
const transferAuth = (params) =>
  http({
    app: 'banyanSi',
    method: 'post',
    url: '/cloud-pharmacy/medins/auth',
    data: params,
    showLoading: true,
    loadingMask: true,
  });

// 处方流转校验授权
const transferCheckAuth = (params) =>
  http({
    app: 'banyanSi',
    method: 'post',
    url: '/cloud-pharmacy/medins/checkAuth',
    data: params,
    showLoading: true,
    loadingMask: true,
  });

export {
  getPrescriptionList,
  getPrescriptionDetail,
  getPrescriptionDetailNew,
  getOrderJumpUrl,
  createByPres,
  getTransferInfo,
  transferAuth,
  transferCheckAuth
};
